var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarToggler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 90.78,
    rx: 32.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 204.61,
    width: 500,
    height: 90.78,
    rx: 32.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 409.22,
    width: 500,
    height: 90.78,
    rx: 32.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarToggler);
export default __webpack_public_path__ + "static/media/navbar-toggler.843ceef5d94b2abd2a06dd30e2e487ef.svg";
export { ForwardRef as ReactComponent };